import UserRow from "./rows/UserRow";

export default class UserGroup {
    constructor(groupName) {
        this.userRows = [];
        this.groupCell = null;
        this.contentDiv = null;
        this.buildGroupCell(groupName);

        let userGroup = this;

        this.expandCollapseListener = function(userRow) {
            userGroup.updateGroupCellRowspan(userRow);
            userGroup.updateGroupCellHeight();
        };
    }

    createUserRow(userId, expandedUsersStorage, today, workingDays) {
        let userRow = new UserRow(userId, expandedUsersStorage, today, workingDays);
        if (this.userRows.length == 0) {
            userRow.getRowEl().appendChild(this.groupCell);
        }
        this.userRows.push(userRow);
        userRow.addExpandCollapseListener(this.expandCollapseListener);
        return userRow;
    }

    buildGroupCell(groupName) {
        this.groupCell = document.createElement("td");
        this.groupCell.className = "userGroupCell";

        this.contentDiv = document.createElement("div");
        this.contentDiv.className = "groupCellContent";
        this.contentDiv.innerHTML = '<span>' + groupName + '</span>';
        this.groupCell.appendChild(this.contentDiv);
    }

    removeBottomBorder() {
        this.groupCell.style.borderBottom = "none";
    }

    updateGroupCellRowspan(collapseExpandRow) {
        if (collapseExpandRow.isExpanded()) {
            this.groupCell.rowSpan += collapseExpandRow.getChildRows().length;
        }
        else {
            this.groupCell.rowSpan -= collapseExpandRow.getChildRows().length;
        }
    }

    updateGroupCellHeight() {
        this.contentDiv.style.height = "auto";
        this.contentDiv.style.height = this.groupCell.clientHeight;
    }

    fitHeightOnBuildDomComplete() {
        let rowspan = 0;
        for (let i = 0; i < this.userRows.length; i++) {
            rowspan += 1;
            if (this.userRows[i].isExpanded()) {
                rowspan += this.userRows[i].getChildRows().length;
            }
        }
        this.groupCell.rowSpan = rowspan;

        this.updateGroupCellHeight();
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/UserGroup.js